import React, { useEffect, useState } from "react";
import InvoiceDetailsTab from "../InvoiceViewModalTabs/InvoiceDetailsTab/InvoiceDetailsTab";
import JobsTab from "../InvoiceViewModalTabs/JobsTab/JobsTab";
import closeIcon from "../../../../../../Assets/images/close-icon.svg";
import { ClipLoader } from "react-spinners";
import apiClient from "../../../../../../Config/apiClient";

const invoicePath = process.env.REACT_APP_HS_CCINVOICES_BASE_PATH;

const InvoiceViewModal = ({ show, onClose, invoiceId, refreshInvoices }) => {
    const [activeTab, setActiveTab] = useState("details");
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show && invoiceId) {
            setActiveTab("details");
            fetchInvoiceData(invoiceId);
        }
    }, [show, invoiceId]);

    const fetchInvoiceData = async (id) => {
        try {
            setLoading(true);
            const res = await apiClient.get(`${invoicePath}/details?id=${id}`);
            setInvoice(res.data.data);
        } catch (err) {
            console.error("Failed to fetch invoice details:", err);
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <>
            <div className="modal-backdrop-custom" onClick={onClose} style={{ position: "fixed", top: 0, left: 0, height: "100vh", width: "100vw", backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 1040, }} />
            <div className="modal right rtm-modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ zIndex: 1050 }}>
                <div className="modal-dialog rtl-dialog">
                    <div className="modal-content rtl-content vjob-content animate__animated animate__fadeInRight" style={{ maxHeight: "100vh", overflow: "hidden" }}>
                        <div className="ajob-content">
                            <div className="cpf-top-no-title">
                                <button className="m-close" onClick={onClose}>
                                    <img src={closeIcon} alt="close" />
                                </button>
                            </div>

                            <div className="viewjob-inner">
                                <div className="aptab-header mt-3">
                                    <ul className="nav nav-tabs tab-line" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className={`nav-link tab-btn ${activeTab === "details" ? "active" : ""}`} onClick={() => setActiveTab("details")} type="button" role="tab" >
                                                Invoice Details
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className={`nav-link tab-btn ${activeTab === "jobs" ? "active" : ""}`} onClick={() => setActiveTab("jobs")} type="button" role="tab" >
                                                Jobs
                                            </button>
                                        </li>
                                    </ul>
                                </div>

                                <div className="aptab-body">
                                    <div className="tab-content">
                                        {loading ? (
                                            <div className="text-center py-5">
                                                <ClipLoader size={30} color="gray" />
                                            </div>
                                        ) : !invoice ? (
                                            <div className="text-center py-5 text-muted">No data found</div>
                                        ) : (
                                            <>
                                                {activeTab === "details" && (
                                                    <div className="tab-pane fade show active" role="tabpanel">
                                                        <InvoiceDetailsTab invoice={invoice} refreshInvoice={() => fetchInvoiceData(invoiceId)} refreshInvoices={refreshInvoices} />
                                                    </div>
                                                )}
                                                {activeTab === "jobs" && (
                                                    <div className="tab-pane fade show active" role="tabpanel">
                                                        <JobsTab jobs={(invoice.jobs || []).map(job => {
                                                            const jobData = (invoice.invoice_jobs || []).find(j => j.job_id === job.id);
                                                            return { ...job, job_amount: jobData?.job_amount || null };
                                                        })} />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InvoiceViewModal;